<template>
    <div class="container">
        <header class="head">
            <Vnav :userName='userName' @command="command" />
        </header>
        <div class="content">
            <aside class="aside">
                <Vaside />
            </aside>
            <section class="section">
                <router-view />
            </section>
        </div>
    </div>
</template>
<script>
import Vnav from "@/components/nav";
import Vaside from "@/components/aside";
import {getUserInfo, removeToken, removetUserInfo, removeUserInfo} from "@/utils/auth";
import { logout } from "@/api/login.js";
export default {
    components: {
        Vnav,
        Vaside,
    },
    data() {
        return {
            userName: "",
        };
    },
    created() {
        this.userName = getUserInfo().loginName;
    },
    methods: {
        command(e) {
            if (e == "logout") {
                this.$confirm("是否退出登录", "提示", {
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    logout().then((res) => {
                        if (res.code == 200) {
                            removeToken();
                            removeUserInfo();
                            this.$router.push("/login");
                        }
                    });
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #e5e5e5;
}
.head {
    width: 100%;
    height: 67px;
    margin-bottom: 16px;
    background: #fff;
}
.content {
    width: 100%;
    height: calc(100% - 83px);
    display: flex;
    .aside {
        width: 208px;
        margin-right: 24px;
        background: #fff;
    }
    .section {
        flex: 1;
        overflow-y: auto;
    }
}
</style>